import {createSlice} from '@reduxjs/toolkit';
import type {PayloadAction} from '@reduxjs/toolkit';
import type {RootState} from '../store';
import {act} from 'react-test-renderer';

export interface EncoderState {
  encoderProgress: number;
}

const initialState: EncoderState = {
  encoderProgress: 0,
};

export const encoderSlice = createSlice({
  name: 'encoder',
  initialState,
  reducers: {
    setEncoderProgress: (state, action: PayloadAction<number>) => {
      state.encoderProgress = action.payload;
    },
  },
});

export const {setEncoderProgress} = encoderSlice.actions;

export default encoderSlice.reducer;
